// extracted by mini-css-extract-plugin
export var inputContainer = "_sz-0";